import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [getAttachments, getSelectedAttachments, getIsFetching] = createSelectors(MODULE, [
  "attachments",
  "selectedAttachments",
  "isFetching",
]);
